import { Mapper } from "../../../../base/utils/mapper";
import { VisualAcuityResponseModel } from "../../../../domain/models/consult/visual-acuity-response.model";
import { VisualAcuityResponseEntity } from "../entities/visual-acuity-response.entity";


export class VisualAcuityImplementationRepositoryMapper extends Mapper<VisualAcuityResponseEntity, VisualAcuityResponseModel> {
    mapFrom(param: VisualAcuityResponseEntity): VisualAcuityResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: VisualAcuityResponseModel): VisualAcuityResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}